/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import jp from 'jsonpath';

let validationSchemaDefinitions = null;
function getDefinitionsFromValidationSchema(schema) {
  return jp.value(schema, '$.definitions');
}

/**
 * Returns the validation schema enum description for an enum code
 * @param enumValue the validation schema enum code
 * @param definition the validation schema enum definition
 * @returns the enum description for a code in the validationSchema
 */
export function getEnumName(enumValue, definition, schema) {
  if (enumValue === '' || typeof schema === 'undefined') return '';
  validationSchemaDefinitions = getDefinitionsFromValidationSchema(schema);
  const enumCodes = validationSchemaDefinitions?.[definition]?.enum;
  const enumNames = validationSchemaDefinitions?.[definition]?.enumNames;
  return enumCodes?.indexOf(enumValue) >= 0 ? enumNames[enumCodes.indexOf(enumValue)] : '';
}
